// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../styles/app.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css */
.sidebar-link {
  display: flex;
  align-items: center;
 
  border-radius: 10px;
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  color: #848485;
  
}


/* Expanded state */
.sidebar-expanded .sidebar-link {
  padding: 14px 10px;
}


/* Icon styling */
.sidebar-icon {
  font-size: 1.5rem; /* Bigger icon */
  color: #848485;

  transition: color 0.2s ease;
  

}


/* Active link styles */
.sidebar-link.active {
  background-color: #FDF5EA;
  color: #F3903F;
  font-weight: 600;
  margin: 4px;


}
.logocomply{
  width: 90%;
  height: 80%;
}

.logoCert{
  width: 60%;
  height: 60%;
  padding-left: 10px;
  padding-top: 27px;
  padding-bottom: 5px;
}

/* أيقونات أكبر عند إغلاق الشريط */
.sidebar-collapsed .sidebar-icon {
  font-size: 2rem;
  padding-bottom: 10px;
  
}


.sidebar-link.active .sidebar-icon {
  color: #F3903F;
}

/* Hover effect */
.sidebar-link:hover {
  background-color: #F8F8F8;
  color: #a1a19f;
  margin: 4px;

  text-decoration: none;
}

.sidebar-link:hover .sidebar-icon {
  color: #a1a19f;

}
/* When sidebar is collapsed */
.sidebar-collapsed .sidebar-link {
  justify-content: center;
  padding: 0px;
  padding-top: 5px;
}

.sidebar-collapsed .sidebar-link span {
  display: none;
}


`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAKA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;;EAEnB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;;AAEhB;;;AAGA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;;AAGA,iBAAiB;AACjB;EACE,iBAAiB,EAAE,gBAAgB;EACnC,cAAc;;EAEd,2BAA2B;;;AAG7B;;;AAGA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,WAAW;;;AAGb;AACA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,oBAAoB;;AAEtB;;;AAGA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;;EAEX,qBAAqB;AACvB;;AAEA;EACE,cAAc;;AAEhB;AACA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf","sourcesContent":["@import '../../styles/app';\n\n\n\n\n/* Sidebar.css */\n.sidebar-link {\n  display: flex;\n  align-items: center;\n \n  border-radius: 10px;\n  text-decoration: none;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  color: #848485;\n  \n}\n\n\n/* Expanded state */\n.sidebar-expanded .sidebar-link {\n  padding: 14px 10px;\n}\n\n\n/* Icon styling */\n.sidebar-icon {\n  font-size: 1.5rem; /* Bigger icon */\n  color: #848485;\n\n  transition: color 0.2s ease;\n  \n\n}\n\n\n/* Active link styles */\n.sidebar-link.active {\n  background-color: #FDF5EA;\n  color: #F3903F;\n  font-weight: 600;\n  margin: 4px;\n\n\n}\n.logocomply{\n  width: 90%;\n  height: 80%;\n}\n\n.logoCert{\n  width: 60%;\n  height: 60%;\n  padding-left: 10px;\n  padding-top: 27px;\n  padding-bottom: 5px;\n}\n\n/* أيقونات أكبر عند إغلاق الشريط */\n.sidebar-collapsed .sidebar-icon {\n  font-size: 2rem;\n  padding-bottom: 10px;\n  \n}\n\n\n.sidebar-link.active .sidebar-icon {\n  color: #F3903F;\n}\n\n/* Hover effect */\n.sidebar-link:hover {\n  background-color: #F8F8F8;\n  color: #a1a19f;\n  margin: 4px;\n\n  text-decoration: none;\n}\n\n.sidebar-link:hover .sidebar-icon {\n  color: #a1a19f;\n\n}\n/* When sidebar is collapsed */\n.sidebar-collapsed .sidebar-link {\n  justify-content: center;\n  padding: 0px;\n  padding-top: 5px;\n}\n\n.sidebar-collapsed .sidebar-link span {\n  display: none;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
